/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';
import {basename} from "@/util/util";

/**
 *
 * @class FileBrowserMetadata
 *
 * @brief meta data for file browser views.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class FileBrowserMetadata extends DocumentMetadata {

  /** the main path being browsed */
  public focus:    string     = '/';

  /** the path to or basename of an element within to focus on (focus is presumed to be a folder) */
  public highlight: string    = '';

  /** standard constructor */
  constructor(
       id:     string = '',
    title:     string = '',
    focus:     string = '/',
     icon:     string = '<i class="fas fa-eye"></i>',
     type: WindowType = WindowType.FileBrowser,
    highlight: string = ''
  ) {

    super(id, title, icon, type);

    this.focus     = focus;
    this.highlight = highlight;
  }

  /** helper to EZ build a file browser launch parameters bag */
  public static build(focus: string, highlight: string=''): FileBrowserMetadata {

    return new FileBrowserMetadata('', basename(focus), focus, '<i class="fas fa-eye"></i>', WindowType.FileBrowser, highlight);
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({focus: this.focus, highlight: this.highlight});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.focus = node.focus;

    if ('highlight' in node) {

      this.highlight = node.highlight;
    }
  }
}
